import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { shallow } from 'zustand/shallow';

import IconButton from '../common/button/IconButton';
import { fontFamily } from '../common/typography/Typography';
import ChevronDown from '../common/icon/ChevronDown';
import AccountCircle from '../common/icon/AccountCircle';
import Avatar from '../common/display/Avatar';

import useUser from '../../store/user';

import { ModifyMetadataContext } from '../../context/ModifyMetadataContext';
import { getTextFromLanguagePack } from '../../utils';
import { ACCOUNT_MANAGEMENT_MENU } from '../../constants/menu';

const PolygonSvg = styled(ChevronDown)`
  transform: ${props => (props['aria-pressed'] ? 'scale(0.8) rotate(180deg)' : 'scale(0.8) rotate(0deg)')};
  transition: 0.1s;
`;

const DropdownBox = styled.div`
  transition: height 0.5s ease 0s;
  ${fontFamily};
  visibility: ${props => (props['aria-pressed'] ? 'visible' : 'hidden')};
  width: max-content;
  height: ${props => (props['aria-pressed'] ? 'auto' : '0px')};
  position: absolute;
  border-radius: 6px;
  background-color: ${props => props.theme.palette.white};
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.25);
  z-index: 9999;
  right: ${({ theme }) => theme.spacing(8)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  & > p {
    font-size: ${({ theme }) => theme.fontSize['14']};
    line-height: 150%;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    color: #888;
    padding: ${({ theme }) => theme.spacing(2, 6)};
    margin: 0;
    text-decoration: none;
    display: block;
    text-align: center;
    &:hover {
      color: ${props => props.theme.palette.black};
    }
    &:not(:last-of-type) {
      border-bottom: 1px solid #ddd;
    }
  }
`;

const DropdownTitle = styled.div`
  ${fontFamily};
  margin-top: auto;
  margin-bottom: auto;
  padding: 0;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
  user-select: none;
  & > p > svg {
    margin-left: ${props => props.theme.spacing(2)};
  }
`;

const UserDropdown = () => {
  const navigate = useNavigate();
  const { user } = useUser(
    state => ({
      user: state.user,
    }),
    shallow
  );
  const [isClicked, setIsClicked] = useState(false);
  const wrapperRef = useRef(null);
  const { isModified, handleModalOpen } = useContext(ModifyMetadataContext);

  useEffect(() => {
    document.addEventListener('mousedown', handleDocClick, false);
    return () => {
      document.removeEventListener('mousedown', handleDocClick, false);
    };
  }, []);

  const handleDocClick = e => {
    if (!wrapperRef.current.contains(e.target)) setIsClicked(false);
  };

  const handleAction = m => {
    if (isModified) {
      if (m.type === 'link') handleModalOpen(() => navigate(m.path, { state: { tab: m.tab } }));
      else if (m.type === 'function') handleModalOpen(() => m.action());
    } else {
      if (m.type === 'link') navigate(m.path, { state: { tab: m.tab } });
      else if (m.type === 'function') m.action();
    }
  };

  return (
    <DropdownTitle className={'gnb-user-dropdown'} ref={wrapper => (wrapperRef.current = wrapper)}>
      {/* <Typography variant={'C4'} onClick={() => setIsClicked(prev => !prev)}>
        {capitalizeText(user?.first_name)}
        <PolygonSvg aria-pressed={isClicked} />
      </Typography> */}
      <IconButton className={'gnb-user-icon'} onClick={() => setIsClicked(prev => !prev)}>
        {user?.avatar ? <Avatar size={'xs'} alt={user?.first_name} src={user?.avatar} /> : <AccountCircle />}
      </IconButton>
      <DropdownBox aria-pressed={isClicked}>
        {ACCOUNT_MANAGEMENT_MENU.map(m => (
          <p onClick={() => handleAction(m)} key={m.lang_code}>
            {getTextFromLanguagePack(m.lang_code)}
          </p>
        ))}
      </DropdownBox>
    </DropdownTitle>
  );
};

export default UserDropdown;
